import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { _sportSponsorTypes, useSportsSponsor } from '../useHelpers/useSportsSponsor'
import { settingsHelpers } from 'global/viewSettings/helpers/settingsHelpers'
import { propDataOpts } from 'global/viewSettings/settingsProps/settingsAll'
import { gEnums } from 'global/enums/globalEnums'
import AppForm from 'global/components/forms/appForms/AppForm'
import { listHelpers } from 'global/lists/lists'
import { Icon, Label } from 'semantic-ui-react'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext'

const CreateSponsors = () => {

  const { getSponsorshipTypes, getSponsors, updateSponsorshipType, updateSponsor, createSponsor, updating } = useSportsSponsor()

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { sponsors } = district_data ?? {}

  const [selectedSponsorType, setSelectedSponsorType] = useState()
  const [selectedSponsor, setSelectedSponsor] = useState()
  const [currentSponsorships, setCurrentSponsorships] = useState({})
  const [currentSponsors, setCurrentSponsors] = useState(sponsors || {})
  const [formData, setFormData] = useState({})
  const [showAddSponsor, setShowAddSponsor] = useState()

  useEffect(() => {
    // createSponsor({ sponsor: { name: "Dick's Sporting Goods", sponsorType: _sportSponsorTypes.season } })
    const cb_sponsorships = (s) => setCurrentSponsorships(s)
    const cb_sponsors = (s) => setCurrentSponsors(s)
    getSponsorshipTypes({ callback: cb_sponsorships })
    // getSponsors({ callback: cb_sponsors })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectedSponsorType = (st) => setSelectedSponsorType(st)

  const handleSelectedSponsor = (s) => {
    setFormData(s)
    setSelectedSponsor(s)

  }

  const handleUpdate_sponsorships = (item) => {
    const _currentSponsorship = _.find(currentSponsorships, { name: item })
    const sponsorship = {
      name: item,
      active: !_currentSponsorship?.active,
    }
    if (_currentSponsorship?._itemKey) {
      sponsorship._itemKey = _currentSponsorship?._itemKey
    }
    updateSponsorshipType({ sponsorship })
  }

  const handleCreate_sponsor = () => {
    createSponsor({
      sponsor: {
        name: formData.name,
        sponsorTypes: formData.sponsorTypes,
      }
    })
    setShowAddSponsor()
  }

  const handleUpdate_sponsor = () => {
    updateSponsor({
      sponsor: {
        name: formData.name,
        sponsorTypes: formData.sponsorTypes,
        active: formData.active,
        _itemKey: formData._itemKey,
      }
    })
  }

  const handleUpdate = () => {
    if (showAddSponsor) {
      handleCreate_sponsor()
    } else {
      handleUpdate_sponsor()
    }
  }

  const handleAddSponsor = () => {
    handleSelectedSponsor({})
    setShowAddSponsor(!showAddSponsor)
  }

  const fsAlt = (item) => {
    const _currentSponsorship = _.find(currentSponsorships, { name: item })
    const { active } = _currentSponsorship ?? {}
    return <Icon name={active ? 'check circle outline' : 'circle outline'} color={active ? 'green' : 'grey'} onClick={(e) => { handleUpdate_sponsorships(item) }} />
  }

  const menu_sponsorTypes = useMemo(() => {
    return <Wrapper
      header={'Sponsor Types'}
      content={<ItemMenuSquares
        menuItems={_sportSponsorTypes}
        activeItem={selectedSponsorType}
        imsType={_imsTypes.inline}
        onClick={handleSelectedSponsorType}
        fn_altContent={fsAlt}
        noItemIcon={true}
      />}
    />
  }, [selectedSponsorType, currentSponsorships])

  const menu_sponsors = useMemo(() => {
    return <Wrapper
      header={'Sponsors'}
      content={<ItemMenuSquares
        menuItems={currentSponsors}
        activeItem={selectedSponsor?.name}
        imsType={_imsTypes.inline}
        onClick={handleSelectedSponsor}
      />}
      footer={<UiSaveButtons save={{ oc: handleAddSponsor, caption: 'Add', icon: 'plus', color: 'blue' }} />}
      wrapperType={wrapperTypes.paddedFooter}
    />
  }, [currentSponsors, selectedSponsor])

  const appFormItems = {
    name: settingsHelpers.newPropObject('name', propDataOpts(true, gEnums.formItemTypes.text)),
    sponsorTypes: settingsHelpers.newPropObject('sponsorTypes', propDataOpts(true, gEnums.formItemTypes.listSelect, null, { trueList: listHelpers.listArray(_sportSponsorTypes) })),
    active: settingsHelpers.newPropObject('active', propDataOpts(false, gEnums.formItemTypes.checkbox)),
  }

  const form_sponsor = () => <AppForm
    appFormItems={appFormItems}
    handleSave={handleUpdate}
    data_parent={formData}
    handleUpdateParentData={setFormData}
    handleSaveCaption={showAddSponsor ? 'Save New Sponsor' : 'Update Sponsor'}
    css={{ content: 'padd10' }}
  />

  const menu_sponsor = () => {

    if (showAddSponsor) {
      return <Wrapper
        header={'Sponsor'}
        content={form_sponsor()}
        updating={updating}
      />
    }

    return <Wrapper
      header={'Sponsor'}
      content={form_sponsor()}
      updating={updating}
    />
  }

  const wvc_sponsors = () => <WrapperVertCols mvc={`3`}  >
    {menu_sponsorTypes}
    {menu_sponsors}
    {menu_sponsor()}
    {/* {selectedYear && menu_vert_steps}
    {selectedYear && wrapper_main()} */}
  </WrapperVertCols>

  return (
    wvc_sponsors()
  )
}

export default CreateSponsors